module.exports = __webpack_public_path__ + "static/media/premioAnual.6ba301ed.png";